export class Doms {
  constructor() {
  }

  setBodyContent(_html) {
    document.body.innerHTML = _html;
  }

  setContainerHTML(_html) {
    let container = document.getElementById('container');
    if (!container) {
      console.error("setContainerHTML:El contenedor no existe.");
      return;
    }

    container.innerHTML = _html;
  }

  getDom(_idElement) {
    return document.getElementById(_idElement);
  }

  setEvent(_idElement, _eventType, _function, _binder) {
    let dom = document.getElementById(_idElement);
    if (!dom) return;

    if (_function) {
      if (_binder) {
        dom.addEventListener(_eventType, _function.bind(_binder));
      } else {
        dom.addEventListener(_eventType, _function);
      }
    }
  }

  setKeyUp(_idElement, _function, _binder) {
    this.setEvent(_idElement, "keyup", _function, _binder);
  }

  setClick(_idElement, _function, _binder) {
    this.setEvent(_idElement, "click", _function, _binder);
  }

  setAttribute(_idElement, _attr, _value) {
    let dom = document.getElementById(_idElement);
    if (!dom) return;
    dom.setAttribute(_attr, _value);
  }

  setStyle(_idElement, _style) {
    let dom = document.getElementById(_idElement);
    if (!dom) return;
    dom.setAttribute("style", _style);
  }

  addClass(_idElem, _class) {
    let dom = document.getElementById(_idElem);
    if (dom) {
      dom.classList.add(_class);
    }
  }

  removeClass(_idElem, _class) {
    let dom = document.getElementById(_idElem);
    if (dom) {
      dom.classList.remove(_class);
    }
  }

  setHTML(_idElement, _html) {
    let dom = document.getElementById(_idElement);
    if (dom) {
      dom.innerHTML = _html || '';
    }
  }

  focus(_idElem) {
    let dom = document.getElementById(_idElem);
    if (dom) {
      dom.focus();
    }
  }

  getValue(_idElement) {
    let dom = document.getElementById(_idElement);
    if (dom) {
      return dom.value || '';
    }
    return '';
  }
  setValue(_idElement, _value) {
    let dom = document.getElementById(_idElement);
    if (dom) {
      dom.value = _value;
    }
  }




  addBodyHTML(_html) {
    document.body.innerHTML += _html;
  }

  setContentHTML(_html) {
    let content = document.getElementById('content');
    if (!content) {
      console.error("setContainerHTML:El contenedor no existe.");
      return;
    }

    content.innerHTML = _html;
  }

  setOnclick(_idElement, _function) {
    let dom = document.getElementById(_idElement);
    if (!dom) return;
    if (typeof _function == 'string') {
      dom.setAttribute('onclick', _function);
    } else {
      this.setClick(_idElement, _function);
    }
  }

  setBackground(_idElement, _url, _force = false) {
    let dom = document.getElementById(_idElement);
    if (!dom) return;
    let style = this.getAttribute('style') || '';
    if (_force === true) {
      style = '';
    }
    dom.setAttribute("style", `${style}; background-image: url(${_url});`);
  }

  toggleClass(_idElem, _class) {
    let dom = document.getElementById(_idElem);
    if (dom) {
      dom.classList.toggle(_class);
    }
  }

  remove(_idElem) {
    document.getElementById(_idElem)?.remove();
  }

  getAttribute(_idElement, _attr) {
    let dom = document.getElementById(_idElement);
    if (dom) {
      return dom.getAttribute(_attr) || '';
    }
    return '';
  }

  getIdcod(_idElement) {
    return this.getAttribute(_idElement, 'idcod');
  }
}
